<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{translations.lblGeneralForm}}</span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>


    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
        <form [formGroup]="formGroup" novalidate>
            <div fxLayout="row" fxLayoutAlign="start right">
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="100">
                    <input matInput placeholder="{{translations.txtCode}}" [(ngModel)]="basicDetails.Code" formControlName="Code" maxlength="25" required>
                </mat-form-field>   
                <mat-error *ngIf="formGroupErrors.Code.required">
                    {{translations.msgEnterCode}}
                </mat-error>
            </div>
            <div fxLayout="row" fxLayoutAlign="start right">
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="100">
                    <input matInput placeholder="{{translations.txtDecsription}}" [(ngModel)]="basicDetails.Description" formControlName="Description" maxlength="100" required>
                </mat-form-field> 
                <mat-error *ngIf="formGroupErrors.Description.required">
                    {{translations.msgEnterDescription}}
                </mat-error>
            </div>
            <div fxLayout="row" fxLayoutAlign="start right">
                <mat-form-field class="mr-24 {{parentRequired ? 'ng-invalid mat-input-invalid mat-form-field-invalid' : ' mat-input-container mat-form-field ng-tns-c18-22 mat-form-field-type-mat-input mat-form-field-can-float mat-primary ng-touched mat-form-field-should-float ng-dirty ng-valid'}}"
                 fxFlex.xs="100" fxFlex="47" *ngIf="parentTypeId > 0">
                    <!-- <mat-select placeholder="{{translations.cmbParent}}" 
                    [(ngModel)]="basicDetails.ParentId" formControlName="ParentId">
                        <ngx-mat-select-search [formControl]="parentFilterCtrl" [noEntriesFoundLabel]="translations.msgNoRecordFound"></ngx-mat-select-search>
                        <mat-option *ngFor="let parent of parentList" [value]="parent.Id">{{parent.Description}} ({{parent.Code}})</mat-option>
                    </mat-select>  -->
                    <input type="text" placeholder="{{translations.cmbParent}} *" 
                    matInput [formControl]="parentFilterCtrl" [matAutocomplete]="auto"  (blur)="onParentBlur($event)">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                        <mat-option *ngFor="let parent of parentList" 
                        value="{{parent.Description}} ({{parent.Code}})"
                        (onSelectionChange)="onParentSelect(parent.Id)"
                        >{{parent.Description}} ({{parent.Code}})</mat-option>
                    </mat-autocomplete>
                    <mat-hint align="start" *ngIf="parentRequired" style="color:red">{{translations.msgSelectParent}}</mat-hint>
                </mat-form-field>
                <!-- <mat-error *ngIf="formGroupErrors.ParentId.required">
                    {{translations.msgSelectParent}}
                </mat-error> -->
            </div>
            <div fxLayout="row" fxLayoutAlign="start right" class="user-active-slider">
                <label style="float: right;display: inline-block;margin-right: 20px;" for="sliderActive" style="float: left;display: inline-block;">{{translations.lblGeneralStatus}}</label>
                <mat-slide-toggle style="float: right;display: inline-block;margin-right: 20px;" [checked]="basicDetails.IsActive" [(ngModel)]="basicDetails.IsActive" formControlName="IsActive" required>{{translations.ckhIsActive}}</mat-slide-toggle>
            </div>
            <div *ngIf="masterTypeId == 31" fxLayout="row" fxLayoutAlign="start left">
                <label style="min-width: 160px;float: left;display: inline-block;" for="sliderEU">{{translations.lblIsEU}}</label>:
                <mat-slide-toggle style="float: left;display: inline-block;margin-left: 10px;" [checked]="basicDetails.IsEU" [(ngModel)]="basicDetails.IsEU" formControlName="IsEU" required>{{translations.ckhIsEU}}</mat-slide-toggle>
            </div>
            <div *ngIf="masterTypeId == 31" fxLayout="row" fxLayoutAlign="start left" style="height: 18px !important;"></div>
            <div *ngIf="masterTypeId == 31" fxLayout="row" fxLayoutAlign="start left">
                <label style="min-width: 160px;float: left;display: inline-block;" for="sliderIncludeInFinance"> {{translations.lblIncludeInFinance}}</label>:
                <mat-slide-toggle style="float: left;display: inline-block;margin-left: 10px;" [checked]="basicDetails.IncludeInFinance" [(ngModel)]="basicDetails.IncludeInFinance" formControlName="IncludeInFinance" required>{{translations.chkIncludeInFinance}}</mat-slide-toggle>
            </div>
            <!--
            <div *ngIf="masterTypeId == 31" fxLayout="row" fxLayoutAlign="start right">
                <label style="float: left;display: inline-block;margin-left: 20px;" for="sliderEU" style="float: left;display: inline-block;">{{translations.lblIsEU}}</label>
                <mat-slide-toggle style="float: left;display: inline-block;margin-left: 20px;" [checked]="basicDetails.IsEU" [(ngModel)]="basicDetails.IsEU" formControlName="IsEU" required>{{translations.ckhIsEU}}</mat-slide-toggle>
            </div> -->

<!--             <section *ngIf="masterTypeId == 31" class="example-section">
              <label style="min-width: 100px;float: left;display: inline-block;" for="sliderEU"> Include In  </label>:
              <mat-checkbox class="example-margin" [(ngModel)]="checked">Finance</mat-checkbox>
              <mat-checkbox class="example-margin" [(ngModel)]="indeterminate">SwissSense Financial</mat-checkbox>
            </section> -->
        </form>

    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
        <button mat-raised-button color="accent" aria-label="SAVE" [disabled]="invalidForm" (click)="save();" fxFlex="47">
            {{translations.btnSave}}
        </button>
        <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
            {{translations.btnClose}}
        </button>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/general/general-edit-form/general-edit-form.component.html